import React from 'react';

export default ({ children, className }) => (
    <a href='/' className={className} onClick={event => event.preventDefault()}>
        { children }
    </a>
);
